// libs
import React, {Fragment, useEffect, useState} from 'react';
// components 
import ConfirmationBox from '../../components/confirmation-box';
import FormModal from './form-modal';
import VariantModal from './variant-modal';
import ImagePreview from '../../components/image-preview-box';
import Button from 'react-bootstrap/Button';
// config & functions 
import config from '../../config';

function Table({loadapidata, offset, list, orgInfo, token, paginationNo, urlaccountid, urlaccountdomain, selectedids = [], ontoggleselect = () => {}}) {
	const [ShowFormModalBox, setShowFormModalBox] = useState(false);
	const [ShowVariantModalBox, setShowVariantModalBox] = useState(false);
    const [ShowDeleteModalBox, setShowDeleteModalBox] = useState(false);
    const [RowId, setRowId] = useState(0);
    const [PreviewImage, setPreviewImage] = useState(false);
    const [PreviewImagePath, setPreviewImagePath] = useState(false);
    const deleteUrl = `${config.api.generic}/inventory`;

	const handFormModal = (ppid) => {
        setRowId(ppid);
        setShowFormModalBox(true);
        setShowDeleteModalBox(false);
        setShowVariantModalBox(false);
    }
	
    const handVariantModal = (ppid) => {
        setRowId(ppid);
        setShowFormModalBox(false);
        setShowDeleteModalBox(false);
        setShowVariantModalBox(true);
    }

    const handleDelete = (rowId) => {
        setRowId(rowId);
        setShowFormModalBox(false);
        setShowDeleteModalBox(true);
        setShowVariantModalBox(false);
    }
    
    const handleDeleteVariant = (ppid, pvid) => {
        setRowId({ppid, pvid});
        setShowFormModalBox(false);
        setShowDeleteModalBox(true);
        setShowVariantModalBox(false);
    }
    
    const handleViewImage = (status, imgName, domain) => {
        setPreviewImagePath(`${config.assets.products}/sas-ecommerce/${domain}/products/large/${imgName}`);
        setPreviewImage(status);
    }

    const PrintImage = ({img, domain}) => {
        if(img) {
            let sa = img.split(",");
            return <div className='border bg-secondary rounded-circle d-flex justify-content-center align-items-center' style={{width: '40px', height: '40px'}} onClick={e => handleViewImage(true, sa[0], domain)}>
                <img src={`${config.assets.products}/sas-ecommerce/${domain}/products/thumbnail/${sa[0]}`} className='img-fluid' style={{width: '40px', height: '40px', borderRadius: '50%'}} />
            </div>
        } else {
            return <div className='border bg-secondary rounded-circle' style={{width: '40px', height: '40px'}}></div>
        }
    }

    useEffect(() => {
        // const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        // const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
        // return () => {
        //     tooltipList.map(t => t.dispose())
        // }
    }, [])

    if(list && Array.isArray(list) && list.length > 0) {
        const pNo = paginationNo ? paginationNo : 1;
        return <>
            <div className="table-responsive">
                <table className="table fs-14rem">
                    <tbody>
                        {list.map((data,i) => {
                            return <Fragment key={Math.random()}>
                                <tr style={{background: '#cdcdcd'}} className="border">
                                    <td style={{background: '#cdcdcd', padding: '0.8rem 0rem'}} valign="middle">
                                        <input className="ms-3" type="checkbox" checked={selectedids.includes(data.pk_id)} onChange={() => ontoggleselect(data.pk_id)} />
                                    </td>
                                    <td style={{background: '#cdcdcd', padding: '0.8rem 0rem'}} className="text-dark fw-bold" valign="middle"><span className="text-dark ms-3">{pNo + '.' + i}</span></td>
                                    <td style={{background: '#cdcdcd', padding: '0.8rem 0rem'}} className="text-dark fw-bold" valign="middle"><span className="text-dark ms-3 me-3">[{data.rid}]</span></td>
                                    <td style={{background: '#cdcdcd', padding: '0.8rem 0rem'}} valign="middle">
                                        <div className="d-flex align-items-center">
                                            <PrintImage img={data.product_image} domain={data.domain} />
                                            <div className="ms-2 text-dark fw-bold">
                                                <span>{data.product_name}</span>
                                                <div className="d-flex mt-1">
                                                    <span className="text-dark me-2 fw-bold">{data.org_account_label},</span> 
                                                    <span className="text-dark me-2 fw-bold">{data.variant?.length || 0} Variant,</span> 
                                                    <span className="text-dark fw-bold">{data.inventory_status || 'N/A'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td style={{background: '#cdcdcd'}} valign="middle" className="text-end">
                                        <div className="btn-group" role="group" aria-label="button group">
                                            <Button variant="secondary" onClick={() => handVariantModal({action: "addNew", ppid: data.pk_id})} className="fs-14rem border-0 text-white">Add Variant</Button>
                                            <Button variant="secondary" onClick={() => handFormModal(data.pk_id)} className="fs-14rem border-0 text-white">Edit</Button>
                                            <Button variant="danger" onClick={() => handleDelete(data.pk_id)} className="fs-14rem border-0 text-white">Delete</Button>
                                        </div>
                                    </td>
                                </tr>
                                {data.variant && <tr key={Math.random()} className="border">
                                    <td colSpan={5} className="py-2">
                                        <table className="table table-sm fs-14rem mb-0">
                                            <thead>
                                                <tr>
                                                    <th style={{minWidth: '200px'}}>SKU Id</th>
                                                    <th style={{minWidth: '80px'}}>Color</th>
                                                    <th style={{minWidth: '145px'}}>Size</th>
                                                    <th style={{minWidth: '120px'}}>Available Stock</th>
                                                    <th style={{minWidth: '120px'}}>MRP</th>
                                                    <th style={{minWidth: '120px'}}>Listing Price</th>
                                                    <th style={{minWidth: '120px'}}>Status</th>
                                                    <th style={{minWidth: '240px'}}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.variant.map(v => {
                                                    return <tr key={Math.random()}>
                                                        <td>{v.skuid}</td>
                                                        <td>{v.color_label}</td>
                                                        <td>{v.size_label}</td>
                                                        <td>{v.quantity}</td>
                                                        <td>Rs {v.mrp}/-</td>
                                                        <td>Rs {v.listing_price}/-</td>
                                                        <td>{v.inventory_status || 'Inactive'}</td>
                                                        <td>
                                                            <Button variant="secondary" onClick={() => handVariantModal({action: "edit", ppid: data.pk_id, pvid: v.pk_id})} className="fs-14rem me-4 p-0 border-0 bg-transparent text-primary">Update Stock</Button>
                                                            <Button variant="secondary" onClick={() => handleDeleteVariant(data.pk_id, v.pk_id)} className="fs-14rem me-2 p-0 border-0 border-0 bg-transparent text-danger">Delete Variant</Button>
                                                        </td>
                                                    </tr>
                                                })}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>}
                            </Fragment>
                        })}
                    </tbody>
                </table>
            </div>
            {(ShowDeleteModalBox) ? <ConfirmationBox loadapidata={loadapidata} apidataparams={(offset == 1) ? 0 : offset} setshowdeletemodalbox={setShowDeleteModalBox} url={deleteUrl} params={(RowId?.ppid && RowId?.pvid) ? {inventoryId: RowId?.ppid, variantId: RowId?.pvid, accountId: urlaccountid} : {id: RowId, accountId: urlaccountid}} token={token} /> : null}
            {(ShowFormModalBox) ? <FormModal loadapidata={loadapidata} apidataparams={(offset == 1) ? 0 : offset} urlaccountid={urlaccountid} urlaccountdomain={urlaccountdomain} setshowformmodalbox={setShowFormModalBox} rowid={RowId} token={token} orginfo={orgInfo} /> : null}
            {(ShowVariantModalBox) ? <VariantModal loadapidata={loadapidata} apidataparams={(offset == 1) ? 0 : offset} setshowvariantmodalbox={setShowVariantModalBox} rowid={RowId} token={token} orginfo={orgInfo} /> : null}
            {(PreviewImage)? <ImagePreview imagepath={PreviewImagePath} handleviewimagefn={handleViewImage} />:null}
        </>
    } else {
        return null;
    }
}

export default Table;